import { render, staticRenderFns } from "./waitMedicine.vue?vue&type=template&id=0b37bae2&scoped=true"
import script from "./waitMedicine.vue?vue&type=script&lang=js"
export * from "./waitMedicine.vue?vue&type=script&lang=js"
import style0 from "./waitMedicine.vue?vue&type=style&index=0&id=0b37bae2&prod&scoped=true&lang=css"
import style1 from "./waitMedicine.vue?vue&type=style&index=1&id=0b37bae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37bae2",
  null
  
)

export default component.exports